const autoNgTemplateLoaderTemplate1 = require('./ldap-group-search.html');

import controller from './ldap-group-search.controller';

export const ldapGroupSearch = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    settings: '=',
    domainSuffix: '@',
    baseFilter: '@',

    onSearchClick: '<',
    limitedFeatureId: '<',
  },
};
